// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"899":"31d6cfe0","6585":"b8179783"}[chunkId] + ".chunk.css";
};